<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">Subterranean Fire</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">© 2006 Sharon Smith</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">First published in 2006 by Haymarket Books</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">This edition published in 2018 </span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">PO Box 180165</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">Chicago, IL 60618</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">773-583-7884</span></p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">www.haymarketbooks.org</span></p>
<p> </p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">ISBN: 978-1-60846-918-5</span></p>
<p> </p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">Cover design by Eric Kerl.</span></p>
<p> </p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">This book was published with the generous <br/>support of the Wallace Global Fund.</span></p>
<p> </p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">Library of Congress Cataloging in Publication Data is available</span></p>
<p> </p>
<p class="Text-body ParaOverride-2"><span class="Text-body CharOverride-4">Printed in Canada by union labor.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?30fc5ff4